import { createApp } from "vue"
import "vuetify/styles"

import vuetify from "./plugins/vuetify"
import "./plugins/echarts"
import snackbar from "./plugins/snackbar"
import vMask from "./plugins/vue-the-mask"
import toolbarLoading from "./plugins/toolbar-loading"
import App from "./App.vue"
import router from "./router"

// TanStack Query imports
import { VueQueryPlugin } from "@tanstack/vue-query"
import { queryClient } from "./queries/client"

// Pinia imports
import { pinia } from "./stores"


import { acl } from "@/acl"
import setupAcl from "./plugins/acl"
import { formatNumberLocal, maskCnpj } from "@/filters"
import { useAuthStore } from "./stores/auth"

// Initialize app
const app = createApp(App)

// Register global filters as properties
app.config.globalProperties.$filters = {
  cnpj: maskCnpj,
  localNumberFormat: formatNumberLocal,
}

app.use(router)
app.use(pinia)
app.use(vuetify)
app.use(snackbar)
app.use(vMask)
app.use(toolbarLoading)

// Setup TanStack Query
app.use(VueQueryPlugin, {
  queryClient,
  enableDevtoolsV6Plugin: true,
})

// Setup ACL after router and Pinia are configured
setupAcl(app, router)

// Initialize ACL with current user from Pinia (before mount so rules are ready for first render)
const authStore = useAuthStore()
acl.reset(authStore.currentUser)

app.mount("#app")

// Expose app globally for debugging
window.app = app
